import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ArrowRight, Check } from "lucide-react";
import api from "@/lib/api";

export const NewsletterForm = ({ testId = "newsletter-form" }) => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", message: "" });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setState({ status: "loading", message: "" });
    try {
      const res = await api.post("/public/newsletter", {
        email,
        language: i18n.language?.startsWith("en") ? "en" : "de",
        source: "home_newsletter",
      });
      const msg =
        res.data?.message === "already_subscribed"
          ? t("home.newsletterDouble")
          : t("home.newsletterSuccess");
      setState({ status: "success", message: msg });
      setEmail("");
    } catch (_) {
      setState({ status: "error", message: t("home.newsletterError") });
    }
  };

  return (
    <form
      onSubmit={onSubmit}
      className="flex flex-col sm:flex-row gap-3 w-full max-w-xl"
      data-testid={testId}
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t("home.newsletterPlaceholder")}
        className="wit-input flex-1"
        aria-label={t("home.newsletterPlaceholder")}
        data-testid="newsletter-email-input"
      />
      <button
        type="submit"
        disabled={state.status === "loading"}
        className="wit-btn-primary justify-center disabled:opacity-60"
        data-testid="newsletter-submit-button"
      >
        {state.status === "success" ? (
          <>
            <Check size={16} /> {t("home.newsletterSubmit")}
          </>
        ) : (
          <>
            {t("home.newsletterSubmit")} <ArrowRight size={16} />
          </>
        )}
      </button>
      {state.message && (
        <div
          role="status"
          className={`sm:basis-full text-sm ${
            state.status === "error" ? "text-coral" : "text-warmGrey"
          }`}
          data-testid="newsletter-message"
        >
          {state.message}
        </div>
      )}
    </form>
  );
};

export default NewsletterForm;
